import React, { ChangeEvent } from 'react';
import * as S from './styles';

interface Option {
  /**
   * A unique value for each option in the select
   */
  readonly value: string;

  /**
   * An optional name to display to the user if you don't
   * want to display the value
   */
  readonly name?: string;
  readonly isDefault?: boolean;
}

interface SelectProps {
  readonly options: Option[];
  readonly selectedValue: string;
  readonly handleSelect: (value: string) => void;
  readonly large?: boolean;
  /** For internal styled-components usage only */
  className?: string;
}

function Select({ options, selectedValue, handleSelect, large, className }: SelectProps) {
  const onSelect = (e: ChangeEvent<HTMLSelectElement>): void => handleSelect(e.target.value);
  return (
    <S.Container className={className}>
      <S.Select
        $large={!!large}
        value={selectedValue}
        onChange={onSelect}
        data-testid="select"
        aria-label={selectedValue}
      >
        {options.map(({ value, name, isDefault }) => (
          <option
            key={value}
            value={value}
            selected={isDefault}
            hidden={isDefault}
            disabled={isDefault}
          >
            {name || value}
          </option>
        ))}
      </S.Select>
      <S.Caret $large={!!large} name="down" />
    </S.Container>
  );
}

export default Select;
